import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

export default class ChangePaymentUrlsRestService extends BaseRestService {

    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    changePaymentUrlByTransactionId(transactionId) {

        return super.getAllAsync(`change-payment-urls?filter[orderid]=${transactionId}`);

    }

}

_serviceDependencies.push(ChangePaymentUrlsRestService);

angular.module('rest.services')
    .service('ChangePaymentUrlsRestService', _serviceDependencies);




// WEBPACK FOOTER //
// ./scripts/restServices/changePaymentUrlsRestService.js